import { useTranslation } from "react-i18next";
import { Box, chakra, Flex, Radio, RadioGroup, Stack, Text } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import * as React from "react";
import { useEffect, useState } from "react";
import { EsgLabel, FormInput, NumericFormInput } from "../../../../../../../components/Forms";
import { translateSubElementString } from "../../../../../../../utils";
import { categoryAttributes, mapData } from "./utils";
import { AnswerField } from "../../../../AnswerField";
function ReusableCategory({ tabKey, currentElement, callMethod, isIncludedAttribute, isPreview }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierQuestionnaire.scopeThree"
  });
  const formDefaultValues = mapData(categoryAttributes, currentElement);

  const [isIncluded, setIsIncluded] = useState("yes");

  useEffect(() => {
    if (currentElement) {
      setIsIncluded(currentElement[isIncludedAttribute] === true ? "yes" : "no");
    }
  }, [currentElement, isIncludedAttribute]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty }
  } = useForm({
    defaultValues: formDefaultValues
  });

  const onSubmit = (data) => {
    if (!isPreview) {
      const apiData = mapData(categoryAttributes, data);
      apiData[isIncludedAttribute] = isIncluded === "yes";
      apiData.categoryKey = tabKey;

      if (isDirty || apiData[isIncludedAttribute] !== currentElement?.[isIncludedAttribute]) {
        callMethod(apiData);
      } else {
        callMethod(null);
      }
      reset({});
    }
  };

  return (
    <chakra.form
      id={`navForm${tabKey}`}
      onSubmit={handleSubmit(onSubmit)}
      flexGrow="1"
      overflowY="auto"
      overflowX="visible"
      paddingBlockEnd="4"
      paddingInline="2"
      marginInline="-2"
      height="calc(100% - var(--chakra-space-24))"
    >
      <Flex direction="column" marginBlockStart={5} gap={5}>
        <Flex direction="column">
          {isPreview ?
            <Box>
              <EsgLabel fontWeight="600" color="gray.700" text={t("includeQuestion", { activity: t(`categories.${tabKey}.activity`) })} />
              <AnswerField
                answerText={isIncluded ?
                  t(`buttons.${isIncluded}`) : ""}
              />
            </Box> :
            <>
              <Text fontSize="sm" opacity="0.75">
                {t("includeQuestion", { activity: t(`categories.${tabKey}.activity`) })}
              </Text>
              <RadioGroup value={isIncluded} mb={5} style={{ position: "relative" }}>
                <Stack spacing={5} direction="row">
                  <Radio
                    colorScheme="customScheme"
                    value="yes"
                    onChange={e => {
                      setIsIncluded(e?.target.value);
                    }}
                  >
                    {t("buttons.yes")}
                  </Radio>
                  <Radio
                    colorScheme="customScheme"
                    value="no"
                    onChange={e => {
                      setIsIncluded(e?.target.value);
                    }}
                  >
                    {t("buttons.no")}
                  </Radio>
                </Stack>
              </RadioGroup>
            </>
          }
        </Flex>

        <Flex direction="column" gap={5}>
          {isIncluded === "yes" ?
            isPreview ?
              <>
                <Box>
                  <AnswerField suffix="tCO2e" answerText={formDefaultValues.carbonEmission?.toString()} />
                </Box>
                <Box>
                  <EsgLabel fontWeight="600" color="gray.700" marginBlockStart={5}
                            text={t("materialityThresholdQuestion", { activity: t(`categories.${tabKey}.activity`) })} />
                  <AnswerField answerText={formDefaultValues.materialityThreshold} />
                </Box>
                <Box>
                  <EsgLabel fontWeight="600" color="gray.700" marginBlockStart={5}
                            text={t("collectDataMethods")} />
                  <AnswerField answerText={formDefaultValues.dataCollectionMethods} />
                </Box>
                <Box>
                  <EsgLabel fontWeight="600" color="gray.700" marginBlockStart={5}
                            text={t("calculationMethods")} />
                  <AnswerField answerText={formDefaultValues.calculationMethods} />
                </Box>
                <Box>
                  <EsgLabel fontWeight="600" color="gray.700" marginBlockStart={5}
                            text={t("howVerifyData")} />
                  <AnswerField answerText={formDefaultValues.howVerifyData} />
                </Box>
              </> :
              <>
                <NumericFormInput
                  label={translateSubElementString("supplierQuestionnaire.scopeThree.emissions")}
                  errors={errors}
                  {...register("carbonEmission")}
                  maxInlineSize={{ base: "full", lg: "lg" }}
                />
                <FormInput
                  label={t("materialityThresholdQuestion", { activity: t(`categories.${tabKey}.activity`) })}
                  errors={errors}
                  {...register("materialityThreshold")}
                  maxInlineSize={{ base: "full", lg: "lg" }}
                />
                <FormInput
                  label={t("collectDataMethods")}
                  errors={errors}
                  {...register("dataCollectionMethods")}
                  maxInlineSize={{ base: "full", lg: "lg" }}
                />
                <FormInput
                  label={t("calculationMethods")}
                  errors={errors}
                  {...register("calculationMethods")}
                  maxInlineSize={{ base: "full", lg: "lg" }}
                />
                <FormInput
                  label={t("howVerifyData")}
                  errors={errors}
                  {...register("howVerifyData")}
                  maxInlineSize={{ base: "full", lg: "lg" }}
                />
              </> :
            isPreview ?
              <Box>
                <EsgLabel fontWeight="600" color="gray.700" marginBlockStart={5}
                          text={t("reasonForExclusion")} />
                <AnswerField answerText={formDefaultValues.reasonExclusion} />
              </Box> :
              <FormInput
                label={t("reasonForExclusion")}
                errors={errors}
                {...register("reasonExclusion")}
                maxInlineSize={{ base: "full", lg: "lg" }}
              />
          }
        </Flex>
      </Flex>
    </chakra.form>
  );
}

export default ReusableCategory;